import { render, staticRenderFns } from "./CertificateModal.vue?vue&type=template&id=9ccf686a&scoped=true"
import script from "./CertificateModal.vue?vue&type=script&lang=js"
export * from "./CertificateModal.vue?vue&type=script&lang=js"
import style0 from "./CertificateModal.vue?vue&type=style&index=0&id=9ccf686a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccf686a",
  null
  
)

export default component.exports